module.exports = __webpack_public_path__ + "fonts/opensans-semibold.e7719558.ttf";